module.exports = __webpack_public_path__ + "assets/7adce710a9f4b00616f27d736bd1c72f.png";